import { render, staticRenderFns } from "./IndexProductList.vue?vue&type=template&id=bb53cd86&scoped=true&"
import script from "./IndexProductList.vue?vue&type=script&lang=js&"
export * from "./IndexProductList.vue?vue&type=script&lang=js&"
import style0 from "./IndexProductList.vue?vue&type=style&index=0&id=bb53cd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb53cd86",
  null
  
)

export default component.exports